export {
	default as CardModal,
	CardModalNotOkButton,
	CardModalType,
	CardModalProps
} from "./card-modal"
export { default as ImageModal }  from "./image-modal"
export { default as SimpleModal } from "./simple-modal"


// WEBPACK FOOTER //
// ./src/component/modal/index.tsx